module.exports = __webpack_public_path__ + "static/img/DSC08020.0a432f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/fali-kepek/DSC08020.jpg
// module id = 555
// module chunks = 0